import React from 'react'
import HubspotForm from 'react-hubspot-form'
import { strings } from 'js/strings'

export default function HubspotFormWrap({ content }) {
  const { portalId, formId } = content
  return (
    <div className='hubspot-form-wrap'>
      <HubspotForm
        portalId={portalId}
        formId={formId}
        // onSubmit={() => console.log('Submit!')}
        // onReady={(form) => console.log('Form ready!')}
        loading={<div>{strings.loading}</div>}
      />
    </div>
  )
}
